import React from 'react';


const TermsModal = ({ open, onAccept, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-[2px] p-2 animate-fadeInModal">
      <div className="w-full max-w-[95vw] sm:max-w-lg bg-white dark:bg-neutral-900 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-2xl p-6 sm:p-10 relative flex flex-col items-center">
        <button onClick={onClose} aria-label="Close" className="absolute top-3 right-3 text-xl text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-200 focus:outline-none">&times;</button>
        <h2 className="mb-4 font-bold text-lg sm:text-xl text-center text-gray-900 dark:text-white">Terms of Service & Disclaimer</h2>
        <div className="max-h-[48vh] overflow-y-auto text-sm sm:text-base leading-relaxed text-gray-700 dark:text-gray-200 text-left pr-1">
          <ul className="list-disc pl-5">
            <li className="mb-2"><b>General:</b> Dolphin is a decentralized, blockchain-based ecosystem. All information is for educational purposes only.</li>
            <li className="mb-2"><b>No Advice:</b> Nothing here is financial, investment, or legal advice. Do your own research.</li>
            <li className="mb-2"><b>No Guarantees:</b> Participation does not guarantee profits or returns. Digital assets are volatile and risky.</li>
            <li className="mb-2"><b>Risks:</b> You accept risks of blockchain, including smart contract bugs, network issues, and loss of access.</li>
            <li className="mb-2"><b>User Responsibility:</b> You control your wallet and actions. The platform cannot reverse or recover transactions.</li>
            <li className="mb-2"><b>Compliance:</b> You are responsible for legal and tax compliance in your jurisdiction.</li>
            <li className="mb-2"><b>Limitation of Liability:</b> The platform and contributors are not liable for any damages or losses.</li>
            <li className="mb-2"><b>Acceptance:</b> By using Dolphin, you agree to these terms.</li>
          </ul>
        </div>
        <div className="flex justify-center gap-4 mt-6">
          <button className="px-6 py-2 rounded-lg font-semibold bg-gradient-to-r from-violet-500 to-cyan-500 text-white border-none" onClick={onAccept}>I Agree</button>
          <button className="px-6 py-2 rounded-lg font-semibold bg-gray-100 dark:bg-neutral-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-neutral-700" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
